import COM from './PageTitle'

export default COM
